import React from 'react';
import styled from '@emotion/styled';
import OtherBankInstallmentRadio from '../radio/OtherBankInstallmentRadio';
import OtherBankInstallmentPrincipal from '../input/OtherBankInstallmentPrincipal';

const Base = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

/**
 *  타금융사 할부조건 할부원금 컨텐츠 컴포넌트
 *  */
function OtherBankInstallmentPrincipalContents(): JSX.Element {
  return (
    <Base>
      <OtherBankInstallmentRadio type='installmentPrincipal' text='할부원금' />
      <OtherBankInstallmentPrincipal />
    </Base>
  );
}

export default OtherBankInstallmentPrincipalContents;
